import { useEffect, useState } from 'react'
import { reaction } from 'mobx'
import { Banner } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { GlobalBanners } from 'widgets/GlobalBanners/GlobalBanners'
import { SuspendedRoutes } from 'pages/suspended/route/type'

const useHostPathname = () => {
  const [pathname, setPathname] = useState(() => window.location.pathname)

  useEffect(() => {
    const sync = () => setPathname(window.location.pathname)

    window.addEventListener('popstate', sync)
    const disposeReaction = reaction(() => uiStore.location, sync)
    const unsubscribeVue = window.RouterVue?.afterEach(sync)

    return () => {
      window.removeEventListener('popstate', sync)
      disposeReaction()
      unsubscribeVue?.()
    }
  }, [])

  return pathname
}

const BannerLayout = () => {
  const pathname = useHostPathname()
  const isSuspendedPage = pathname.startsWith(`/${SuspendedRoutes.root}`)

  if (isSuspendedPage) return null

  return <Banner globalBanners={<GlobalBanners />} />
}

export default BannerLayout
